// @flow

import { rem } from 'polished';
import React from 'react';
import { useSelector } from 'react-redux';
import styled, { type StyledComponent } from 'styled-components';

import config from '../../../config/app.config.js';
import { __ } from '../../../i18n/l10n';
import type { RootState } from '../../../store/types';
import { colors, fontFamily } from '../../../styles/GlobalStyle';

type ToasterRawProps = {
  className: string
};

const ToasterRaw = ({ className }: ToasterRawProps) => {
  const websocket = useSelector((state: RootState) => state.websocket);

  if (!config.isDebug) return null;
  if (websocket.connected) return null;

  return <div className={className}>{!config.isMockUp ? __('Not connected') : 'Mockup'}</div>;
};

export const Toaster: StyledComponent<ToasterRawProps, {}, typeof ToasterRaw> = styled(ToasterRaw)`
  position: fixed;
  height: 10px;
  left: 0;
  bottom: 0;
  background-color: ${colors.red};
  z-index: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 15px;
  color: #fff;
  font-size: ${rem(10)};
  font-weight: ${fontFamily.primary.black.fontWeight};
  text-transform: uppercase;
  opacity: 0.8;
`;
